module.exports = __webpack_public_path__ + "imgs/instagram-color.f95207fc0a0f1996a849b7f75604073d.svg";